import React from 'react';
import '../../styles/dashboard/WelcomeBanner.css';

const WelcomeBanner = () => {
  return (
    <div className="welcome-banner">
      <h2>Welcome Back!</h2>
    </div>
  );
};

export default WelcomeBanner;
